import PropTypes from 'prop-types'

const Empty = ({ text = 'Данные отсутствуют' }) => (
  <div className="flex w-full items-center justify-center rounded-[16px] border border-dashed border-[#e5e7eb] bg-white px-[1.5rem] py-[3rem] text-[0.938rem] text-[#9ca3af]">
    {text}
  </div>
)

Empty.propTypes = {
  text: PropTypes.string,
}

export default Empty
